import '.f6{font-size:1.125rem;}.ssr-plugin'
import '.ds{line-height:1.75rem;}.ssr-plugin'
import '.bt{text-decoration:none;}.ssr-plugin'
import '.gf{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="f6 ds"
    >
      {translations.privacySubtitle}{' '}
      <a className="bt gf"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="bt gf"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
